import { Table, Text } from '@mantine/core';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import type { DebtorBalanceCreditNote } from 'shared/hooks/use-load-debtor-balance';
import { NumberFormatterTable } from '../hooks/use-balance-table-columns';

type CreditNoteRowProps = {
  creditNote: DebtorBalanceCreditNote;
};

export const CreditNoteRow = ({ creditNote }: CreditNoteRowProps) => {
  const { t } = useTranslation();

  const { totalTvac, invoices = [], payments = [] } = creditNote;

  return (
    <>
      {/* Credited total */}
      <Table.Tr>
        {makeSpacer(1)}
        <Table.Td>
          <Text fw={500} size="sm">
            {t(i18nKeys.AMOUNT_CREDITED)}
          </Text>
        </Table.Td>
        {makeSpacer(3)}
        <Table.Td>
          <NumberFormatterTable value={totalTvac * -1} />
        </Table.Td>
        {makeSpacer(1)}
      </Table.Tr>

      {/* Linked invoices */}
      {invoices.map(invoice => (
        <Table.Tr key={invoice.reference}>
          {makeSpacer(1)}
          <Table.Td>
            <Text fw={500} size="sm">
              {t(i18nKeys.INVOICE.LINK_INVOICE)} – {invoice.reference}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text fw={500} size="sm">
              {invoice.date.format('L')}
            </Text>
          </Table.Td>
          {makeSpacer(1)}
          <Table.Td>
            <NumberFormatterTable value={invoice.amount} />
          </Table.Td>
          {makeSpacer(2)}
        </Table.Tr>
      ))}

      {/* Linked payments */}
      {payments.map(payment => (
        <Table.Tr key={`${payment.communication}-${payment.amount}`}>
          {makeSpacer(1)}
          <Table.Td>
            <Text fw={500} size="sm">
              {t(i18nKeys.LINKED_PAYMENT)} – {payment.communication}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text fw={500} size="sm">
              {payment.issueDate?.format('L') ?? t(i18nKeys.MISSING_DATA)}
            </Text>
          </Table.Td>
          {makeSpacer(1)}
          <Table.Td>
            <NumberFormatterTable value={payment.amount * -1} />
          </Table.Td>
          {makeSpacer(2)}
        </Table.Tr>
      ))}
    </>
  );
};

export const makeSpacer = (count: number) =>
  Array.from({ length: count }).map((_, i) => <Table.Td key={`sp-${i}`} />);
